import { dataTypeOptions, storageEnvTypeOptions } from "../../../../../config/constants";
import { PER_WEIGHT_UNITS } from "../../../../../config/optionsConstants";
import { StorageFormValues } from "../types/storageTable.types";

export const DATA_TYPE_OPTIONS = dataTypeOptions.map(o => ({ value: o.text, label: o.text }));

export const ENV_OPTIONS = storageEnvTypeOptions.map(o => ({ value: o.text, label: o.text }));

export const WEIGHT_UNIT_OPTIONS = PER_WEIGHT_UNITS.map(o => ({ value: o.value, label: o.text }));

export const DEFAULT_FORM_VALUES: StorageFormValues = {
  id: "",
  name: "",
  dataType: "Specific",
  environment: "",
  warehouseName: "",
  storageTemperature: "",
  warehouseSize: "",
  weight: "",
  weightUnit: "kg",
  electricity: "",
  utilization: "",
  storageDays: ""
};
